import type { GeoPoint } from '../types/drawing.js';
import { destinationPoint } from './geo-math.js';

/**
 * Project a moving object's future position by dead reckoning along its heading.
 * Reuses the great-circle {@link destinationPoint} — a constant-speed, constant-
 * heading extrapolation for predicted-trajectory (velocity-vector) rendering.
 *
 * @param origin   Current position.
 * @param headingDeg Course over ground in degrees (0 = north, clockwise).
 * @param speedMs  Ground speed in metres per second.
 * @param seconds  Look-ahead time in seconds.
 * @returns The projected position after `seconds` at the given speed and heading.
 */
export function projectPosition(
  origin: GeoPoint,
  headingDeg: number,
  speedMs: number,
  seconds: number,
): GeoPoint {
  return destinationPoint(origin, headingDeg, speedMs * seconds);
}
